export const hasMetamask = () => 'ethereum' in window;
